import { useSuspenseQuery } from '@tanstack/react-query';
import { Suspense } from 'react';

import { SignInForm } from '@/components/auth/sign-in-form';
import { meQuery } from '@/queries';
import { STOREFRONT_OPEN } from '@/storefront';

export default function SignInPage() {
  const { supabaseConfigured } = useSuspenseQuery(meQuery).data;

  return (
    <div className="mx-auto max-w-[440px] px-5 py-16">
      <h1 className="text-[32px] font-semibold tracking-[-0.02em]">Sign in</h1>
      {/* The storefront copy promises screens a closed store does not serve.
          Offering to "track orders" on the only page a visitor can reach, when
          every order screen redirects back here, reads as a broken site rather
          than a closed one. */}
      <p className="mt-2 text-[15px] text-muted">
        {STOREFRONT_OPEN
          ? 'Track orders, approve proofs and reorder past jobs.'
          : 'Sign in to run orders, stock and production.'}
      </p>
      {/* The form reads ?next= to bounce back where you came from, which opts
          it into client-side rendering. The boundary keeps the page static. */}
      <div className="mt-8">
        <Suspense fallback={<div className="h-80 animate-pulse rounded-[10px] bg-panel" />}>
          <SignInForm supabaseReady={supabaseConfigured} />
        </Suspense>
      </div>
    </div>
  );
}
